module.exports = __webpack_public_path__ + "media/images/homes/location-4897781c512fedc04ebb4f6799dbe2a6.svg";